import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'
import TextInputComponent from '@components/textInput/TextInput'

import theme from '@theme/Theme'
import useI18n from '@i18n/useI18n'

type Props = {
  onFilter: () => void
  onExport: () => void
  onSearch: (text: string) => void
  onBack: () => void
  search: string
  filtersSize: number
  title: string
  canDownload: boolean
}

const EDLListHeaderMobile = ({
  onFilter,
  onExport,
  onSearch,
  onBack,
  search,
  filtersSize,
  title,
  canDownload,
}: Props) => {
  const i18n = useI18n()

  return (
    <MainContainer>
      <ContentContainer>
        <LeftButton activeOpacity={0.9} onPress={onBack}>
          <Icon name="arrow-left" size={35} color={theme.colors.background} />
        </LeftButton>

        <Title>{title}</Title>
        <RightContainer>
          <TouchableOpacity activeOpacity={0.9} onPress={onFilter}>
            {filtersSize !== 0 && (
              <Pillule>
                <NumberOfFilter>{filtersSize}</NumberOfFilter>
              </Pillule>
            )}
            <Icon name="filter" size={35} color={theme.colors.background} />
          </TouchableOpacity>
          {canDownload && (
            <TouchableOpacity activeOpacity={0.9} onPress={onExport}>
              <Icon name="download" size={35} color={theme.colors.background} />
            </TouchableOpacity>
          )}
        </RightContainer>
      </ContentContainer>
      <SubHearder>
        <TextInputComponent
          onChange={onSearch}
          searchStyle="onDark"
          placeholder={i18n.t('screens.incidentList.search')}
          left={{ name: 'search' }}
          value={search}
        />
      </SubHearder>
    </MainContainer>
  )
}

export default EDLListHeaderMobile

const MainContainer = styled(View)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.primary};
`

const ContentContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  height: 30px;
  margin-top: ${(props) => props.theme.insets.top}px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => props.theme.colors.background};
  flex: 2;
  text-align: center;
`

const RightContainer = styled(View)`
  flex: 1;
  justify-content: space-between;
  flex-direction: row-reverse;
`

const LeftButton = styled(TouchableOpacity)`
  flex: 1;
  align-items: flex-start;
`

const SubHearder = styled(View)`
  margin-top: 20px;
`

const Pillule = styled(View)`
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.alertButton};
  height: 20px;
  width: 20px;
  border-radius: 10px;
  position: absolute;
  right: -5px;
`

const NumberOfFilter = styled(Text)`
  ${(props) => props.theme.fonts.Caption1};
  color: ${(props) => props.theme.colors.background};
`
